import apiClient from "./apiClient";

/**
 * Config pública (AllowAny) — backend: GET /api/site-config/public/
 * No usar /api/config/: requiere IsAuthenticated y provoca 401 en visitantes.
 */
export const fetchPublicSiteConfig = async () => {
  try {
    const response = await apiClient.get("/site-config/public/", {
      timeoutSet: true,
      timeout: 15000,
    });
    const data = response.data;
    if (data && Array.isArray(data.results) && data.results.length) {
      return data.results[0];
    }
    return data;
  } catch (e) {
    console.warn("fetchPublicSiteConfig: no disponible", e?.message || e);
    return null;
  }
};

export const getSiteConfig = async () => {
  try {
    const token = localStorage.getItem('accessToken');
    const response = await apiClient.get('/config/', {
      headers: {
        Authorization: `Bearer ${token}`
      }
    });
    return response.data;
  } catch (error) {
    console.error('Error fetching site configuration:', error);
    throw error;
  }
};

export const getSiteConfigFromViewSet = async () => {
  try {
    const token = localStorage.getItem('accessToken');
    const response = await apiClient.get('/site-config/', {
      headers: {
        Authorization: `Bearer ${token}`
      }
    });
    
    // Handle paginated response
    if (response.data.results && Array.isArray(response.data.results)) {
      return response.data.results.length > 0 ? response.data.results[0] : null;
    } else if (Array.isArray(response.data)) {
      return response.data.length > 0 ? response.data[0] : null;
    }
    
    return response.data;
  } catch (error) {
    console.error('Error fetching site configuration from viewset:', error);
    throw error;
  }
};

export const updateSiteConfig = async (configData) => {
  try {
    const token = localStorage.getItem('accessToken');
    // First try to get existing config to see if we need to create or update
    let response;
    try {
      const existingConfig = await apiClient.get('/site-config/', {
        headers: {
          Authorization: `Bearer ${token}`
        }
      });
      
      if (existingConfig.data.results && existingConfig.data.results.length > 0) {
        // Update existing config
        const configId = existingConfig.data.results[0].id;
        response = await apiClient.patch(`/site-config/${configId}/`, configData, {
          headers: {
            Authorization: `Bearer ${token}`
          }
        });
      } else if (existingConfig.data.length > 0) {
        // Update existing config (non-paginated response)
        const configId = existingConfig.data[0].id;
        response = await apiClient.patch(`/site-config/${configId}/`, configData, {
          headers: {
            Authorization: `Bearer ${token}`
          }
        });
      } else {
        // Create new config
        response = await apiClient.post('/site-config/', configData, {
          headers: {
            Authorization: `Bearer ${token}`
          }
        });
      }
    } catch (getError) {
      // If getting config fails, try to create a new one
      response = await apiClient.post('/site-config/', configData, {
        headers: {
          Authorization: `Bearer ${token}`
        }
      });
    }
    
    return response.data;
  } catch (error) {
    console.error('Error updating site configuration:', error);
    throw error;
  }
};
